import { setTerm } from './helpers';

export const setFlatShare = setTerm('flat_share');
